import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration';
import { Card } from 'antd';
import { EditLayout } from 'components/layout/layout/EditLayout';
import { FileDoneOutlined } from '@ant-design/icons';
import { FormAssessment } from './components/FormAssessment';
import { IAssessment } from 'interfaces/assessments';
import { PageHeader } from 'components/professor_area/PageHeader';
import { useForm } from '@refinedev/antd';

dayjs.extend(duration);

export const AssessmentEdit = () => {
  const form = useForm<IAssessment>({
    redirect: 'edit'
  });

  return (
    <EditLayout saveButtonProps={form.saveButtonProps}>
      <PageHeader title="Editar Avaliação" icon={FileDoneOutlined} />
      <Card>
        <FormAssessment formInstance={form} />
      </Card>
    </EditLayout>
  );
};
